import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDatewithNullCheck } from '../../../utils/formatting';
import { RouteComponentProps } from 'react-router-dom';
import {getValueOrDefault} from '../../../utils/NullCheck/index'

interface GasBoilerCardProps extends RouteComponentProps<any> {
  GASPropsData:any
}

const GasBoilerServicing: React.FC<GasBoilerCardProps> = ({GASPropsData}) => {
  const { t } = useTranslation();


  return (
    <div className="body-card row m-0 border-terracotta display-column">
        <h4>{t("GasBoiler")}</h4>
        <div className="gas-boiler-card mt-4 p-0">
        <div className='record-repair justify-between pb-16'><h6>{t("Due_Date")}</h6>
            <p>{formatDatewithNullCheck(GASPropsData?.visitDue)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Contractor")}</h6>
            <p>{getValueOrDefault(GASPropsData?.contractor?.contractorName)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Contractor_Contact")}</h6>
            <p>{getValueOrDefault(GASPropsData?.contractor?.contractorNumber)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Last_Visit")}</h6>
            <p>{formatDatewithNullCheck(GASPropsData?.visitActual)}</p></div>
          <div className='record-repair justify-between pb-16'><h6>{t("Visit_Outcome")}</h6>
            <p>{getValueOrDefault(GASPropsData?.visitOutcome)}</p></div>
        </div>
    </div>
  );
};

export default GasBoilerServicing;